import styles from './PageHeaderRowEnganced.module.scss';

export interface IPageHeaderRowEngancedProps {
    children: any;
}

export function PageHeaderRowEnganced(props: IPageHeaderRowEngancedProps) {
    return (<div className={styles.host}>{props.children}</div>);
}
